import { throwErrorMessage } from 'dashboard/store/utils/api';
import ConversationApi from '../../../../api/inbox/conversation';
import mutationTypes from '../../../mutation-types';

export default {
  markMessagesRead: async ({ commit, dispatch }, data) => {
    try {
      const {
        data: { id, agent_last_seen_at: lastSeen },
      } = await ConversationApi.markMessageRead(data);
      setTimeout(() => {
        commit(mutationTypes.UPDATE_MESSAGE_UNREAD_COUNT, { id, lastSeen });
        dispatch('fetchAllUnreadConversations');
      }, 2000);
    } catch (error) {
      // Handle error
    }
  },

  markMessagesUnread: async ({ commit, dispatch }, { id }) => {
    try {
      const {
        data: { agent_last_seen_at: lastSeen, unread_count: unreadCount },
      } = await ConversationApi.markMessagesUnread({ id });
      commit(mutationTypes.UPDATE_MESSAGE_UNREAD_COUNT, {
        id,
        lastSeen,
        unreadCount,
      });
      dispatch('fetchAllUnreadConversations');
    } catch (error) {
      throwErrorMessage(error);
    }
  },
};
